import "#legacy/admin/assessment_builder/_generated_templates.js";
import "#legacy/admin/assessment_builder/events.js";
import "#legacy/admin/assessment_builder/models/response.js";
import "#legacy/admin/assessment_builder/views/list.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Views ??= {};

AssessmentBuilder.Views.ResponseFormChoices = class ResponseFormChoices extends AssessmentBuilder.Views.List {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.removeResponse = this.removeResponse.bind(this);
    this.newResponseAttributes = this.newResponseAttributes.bind(this);
  }

  initialize(options = {}) {
    this.options = options;
    super.initialize({ ...options, sortable: true });
    return this.listenTo(this.collection, "add remove", this.render);
  }

  render() {
    this.$el.html(this.template());
    this.$(".choices-container").html(this.buildList());
    return this;
  }

  // EVENT HANDLERS

  handleResponseRemoveClicked(_, response) {
    return this.removeResponse(response);
  }

  // HELPER FUNCTIONS

  addResponse() {
    return this.collection.add(new AssessmentBuilder.Models.Response(this.newResponseAttributes()));
  }

  removeResponse(response) {
    return this.collection.remove(response);
  }

  newResponseAttributes() {
    return {
      ...this.options.newResponseAttributes,
      position: this.collection.length,
    };
  }
};
AssessmentBuilder.Views.ResponseFormChoices.prototype.tagName = "choices-response-form";
AssessmentBuilder.Views.ResponseFormChoices.prototype.template = _.template(
  AssessmentBuilder.Templates.Response.Form.choices,
);
AssessmentBuilder.Views.ResponseFormChoices.prototype.listItemViewClass = "AssessmentBuilder.Views.ResponseFormChoice";

AssessmentBuilder.Views.ResponseFormChoices.prototype.events = {
  "click add-response-button": "addResponse",
  [AssessmentBuilder.Events.Response.removeClicked]: "handleResponseRemoveClicked",
};
